module.exports = __webpack_public_path__ + "static/media/heart.191a2aa7.svg";